<template>
	<div>
        <h3>Machine Learning</h3>

		<h3>Entrainement</h3>

		<p><b>Données initiales</b></p>

		<b-select v-model="type_data_test" :options="[
			{value: 'tabulator', text: 'Tableau'},
			{value: 'database', text: 'Base de données'},
			{value: 'DatabaseRequestView', text: 'Base de données - multitables'},
		]" />

		<br /><br />

		<div v-if="type_data_test == 'tabulator'">
			<edit_tabulator @update="import_file" ref="tabulator"></edit_tabulator>
		</div>

		<DatabaseRequestView v-if="type_data_test == 'DatabaseRequestView'"
			@update="import_file"
			_type="db"
			:minimal="true"
			ref="tabulator" />

		<div v-if="type_data_test == 'database'">
			<database
				@update="import_file"
				:change_table="true"
				:name="false"
				:edit="false"
				ref="tabulator"></database>
		</div>

		<b>Options</b>

		<p>
			Colonnes d'entrée
			<array_editor ref="start_data" @update="update_columns"></array_editor>
		</p>
		<p>
			Colonne de résultats attendus
			<b-input v-model="params.result_column"></b-input>
		</p>
		<p>
			Colonne de résultats
			<b-input v-model="params.prediction_column"></b-input>
		</p>
		<p>
			Taille des données de test (entre 0 et 1)
			<b-input type="number" :min="0" :max="1" step="0.1" v-model="params.test_size"></b-input>
		</p>


		<b-button @click="train">Entraîner</b-button>

		<div v-html="html"></div>

		<edit_tabulator :extern_file="false" ref="train_tabulator"></edit_tabulator>	

		<div v-if="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>

		<h3>Exécuter</h3>

		<p><b>Données initiales</b></p>

		<b-select v-model="type_data_execute" :options="[
			{value: 'tabulator', text: 'Tableau'},
			{value: 'database', text: 'Base de données'},
			{value: 'DatabaseRequestView', text: 'Base de données - multitables'},
		]" />

		<br /><br />

		<div v-if="type_data_execute == 'tabulator'">
			<edit_tabulator @update="import_file_execute" ref="tabulator_execute"></edit_tabulator>
		</div>

		<DatabaseRequestView v-if="type_data_execute == 'DatabaseRequestView'"
			@update="import_file_execute"
			_type="db"
			:minimal="true"
			ref="tabulator_execute" />

		<div v-if="type_data_execute == 'database'">
			<database
				@update="import_file_execute"
				:change_table="true"
				:name="false"
				:edit="false"
				ref="tabulator_execute"></database>
		</div>

		<b>Options</b>

		<p>
			Colonnes d'entrée
			<array_editor ref="start_data_execute" @update="update_columns_execute"></array_editor>
		</p>
		<p>
			Colonne de résultats
			<b-input v-model="params_execute.prediction_column"></b-input>
		</p>

		<b-button @click="execute">Exécuter</b-button>

		<edit_tabulator :extern_file="false" ref="result_tabulator"></edit_tabulator>	

		<div v-if="spinner" class="center_spinner">
			<fade-loader></fade-loader>
		</div>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
	import workers from "../services/workers.js";
    import database from "../services/database.js";
	import projects from "../services/projects.js";
	import databaseView from "../views/database.vue";
	import treatments from "../services/treatments.js";
	import treatment from "../components/treatment.vue";
	import c_treatment_params from "../components/params.vue";
    import array_editor from "../components/array_editor.vue";
	import edit_tabulator from "../components/edit_tabulator.vue";
    import DatabaseRequestView from '../views/DatabaseRequestView.vue';

	var clone = require("clone");

	import moment from "moment";
	require('moment/locale/fr')

	import * as json2csv from "json2csv";
	import draggable from "vuedraggable";
	import FadeLoader from "vue-spinner/src/FadeLoader.vue";

	export default {
		name: "machine_learning",
		components: {
			edit_tabulator,
			database: databaseView,
			DatabaseRequestView,
			FadeLoader,
			array_editor
		},
		props: {
			name: {}
		},
		data() {
			return {
                id: uniqueId(""),

				type_data_test: "tabulator",
				type_data_execute: "tabulator",
				spinner: false,

				test_data: [],
				test_data_execute: [],

				error: "",

				params: {},
				params_execute: {},
				html: ""
			};
		},
		watch: {
		},
		methods: {
			update_columns(columns)
			{
				this.params.columns = columns;
			},
			update_columns_execute(columns)
			{
				this.params_execute.columns = columns;
			},
			import_file()
			{
				console.log("import_file")
				this.test_data = this.$refs.tabulator.get_data();
			},
			import_file_execute()
			{
				console.log("import_file")
				this.test_data_execute = this.$refs.tabulator.get_data();
			},
			async train()
			{
				console.log("train");

				this.error = "";
				this.spinner = true;
				this.error = ""

				this.test_data = await this.$refs.tabulator.get_data();
				var str_csv = json2csv.parse(this.test_data, {
					fields: Object.keys(this.test_data[0]),
					fieldNames: Object.keys(this.test_data[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0]);
				formData.append("action", "prediction");
				formData.append("parameters", JSON.stringify({
					columns: this.params.columns,
					result_column: this.params.result_column,
					prediction_column: this.params.prediction_column || "result",
					action: "train",
					model: "by_ml",
					model_id: this.name,
					html: true,
					test_size: this.params.test_size || 0.5
				}));

				try
				{
					var data = await workers.test(formData);

					console.log(data)

					for (var i = 0; i < data.data.files.length; i++)
					{
						console.log(data.data.files[i].name)
						if (data.data.files[i].name.endsWith(".html"))
						{
							this.html = await treatments.getFileAlyx(
								data.data.files[i].url,
								false,
								false
							);
						}
						if (data.data.files[i].name.endsWith(".csv"))
						{
							var data_train = await treatments.getFileAlyx(
								data.data.files[i].url,
								false,
								false
							);

							data_train = this.$papa.parse(data_train, { header: true });
							data_train = data_train.data;
							
							this.$refs.train_tabulator.set_data(data_train);
						}
					}

					console.log(data)
				}
				catch (err)
				{
					this.error = err;
					this.spinner = false;				
					return;
				}

				this.spinner = false;
			},
			async execute()
			{
				console.log("execute");

				this.error = "";
				this.spinner = true;
				this.error = ""

				this.test_data_execute = await this.$refs.tabulator_execute.get_data();
				var str_csv = json2csv.parse(this.test_data_execute, {
					fields: Object.keys(this.test_data_execute[0]),
					fieldNames: Object.keys(this.test_data_execute[0]),
				});

				var files = [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];

				var formData = new FormData();
				formData.append(files[0].name, files[0]);
				formData.append("action", "prediction");
				formData.append("parameters", JSON.stringify({
					columns: this.params_execute.columns,
					prediction_column: this.params_execute.prediction_column || "result",
					action: "predict",
					model: "by_ml",
					model_id: this.name
				}));

				try
				{
					var data = await workers.test(formData);

					console.log(data)

					for (var i = 0; i < data.data.files.length; i++)
					{
						console.log(data.data.files[i].name)
						if (data.data.files[i].name.endsWith(".csv"))
						{
							var data_train = await treatments.getFileAlyx(
								data.data.files[i].url,
								false,
								false
							);

							data_train = this.$papa.parse(data_train, { header: true });
							data_train = data_train.data;
							
							this.$refs.result_tabulator.set_data(data_train);
						}
					}

					console.log(data)
				}
				catch (err)
				{
					this.error = err;
					this.spinner = false;				
					return;
				}

				this.spinner = false;
			},
			async load(data)
			{
				var self = this;

				if (data.type_data_test)
					this.type_data_test = data.type_data_test;
				else
					this.type_data_test = "tabulator";

				if (data.type_data_execute)
					this.type_data_execute = data.type_data_execute;
				else
					this.type_data_test = "tabulator";

				if (data.params_execute)
					this.params_execute = data.params_execute;

				this.params = data.params;
				this.$refs.start_data.load(data.params.columns || [])
				this.$refs.start_data_execute.load(data.params_execute ? data.params_execute.columns || [] : [])

                self.$nextTick(async function () {
					if (data.test_data)
					{
						self.$refs.tabulator.load(data.test_data);
					}
					if (data.test_data_execute)
					{
						self.$refs.tabulator_execute.load(data.test_data_execute);
					}
				});
			},
			async save()
			{
				var data = await this.$refs.tabulator.save();
				var data_execute = await this.$refs.tabulator_execute.save();

				return {
					test_data: data,
					test_data_execute: data_execute,
					type_data_test: this.type_data_test,
					params: this.params,
					params_execute: this.params_execute
				}
			},
		},
		mounted: async function () {
		},
	};
</script>

<style>
.center_spinner {
	width: 0%;
	margin: 0 auto;
	margin-top: 30px;
}
</style>
